/*--- .Add To Cart ---*/
import * as $ from 'jquery'
import { customSelect } from './main'

const donationAppChanges = () => {
    const observer = new MutationObserver((mutations, e) => {
        const donationWrapper = document.querySelectorAll('.donate-div')

        donationWrapper.forEach(el => {
            const copyText = el.querySelector('.gng-ru--mainCopy span')
            const searchForText = 'Thank you for donating'

            if (copyText && copyText.innerText.includes(searchForText)) {
                copyText.parentElement.style.display = 'block'

                e.disconnect()
            }
        })
    })

    observer.observe(document, {
        subtree: true,
        childList: true
    })
}

$(window).on('load', donationAppChanges)

$(document).ready(function () {
    let $body = $('body')

    donationAppChanges()

    $(document).click(function (e) {
        let $cartPopupWrapper = $('.cart-popup-wrapper')
        if ($cartPopupWrapper.hasClass('d-block') && $(e.target).parents('.cart-popup-wrapper').length === 0) {
            $cartPopupWrapper.removeClass('d-block')
            $cartPopupWrapper.addClass('d-none')
        }
    })

    const shopifyAPI = (action, data, type = null) => {
        return $.ajax({
            url: `${window.language}/cart/${action}.js`,
            dataType: 'json',
            cache: false,
            type: 'post',
            data,
            success: function () {
                if ($('.cart-header').data("add-rose")) {
                    getCartData();   
                }
                updateCart(type)
                updateCartQuantity()
            }
        })
    }

    const getAddons = (form) => {
        let addons = []
        const sellingPlan = form.find(x => x.name === 'selling_plan')
        const parentId = form.find(x => x.name === 'id')

        for (let i = 1; i <= 5; i++) {
            const addon = form.find(x => x.name === `addon${i}`)
            if (addon) {
                const addonItem = {id: addon.value}
                if (sellingPlan) {
                    const addonSellingPlan = form.find(x => x.name === `addon_selling_plan${i}`)
                    if (addonSellingPlan) {
                        addonItem.selling_plan = addonSellingPlan.value
                    }
                }
                addonItem.properties = {p: parentId.value}
                addons.push(addonItem)
            }
        }

        return addons
    }

    const addToCartData = ($addToCartForm) => {
        let data = $addToCartForm.serialize()

        const form = $addToCartForm.serializeArray()

        // Add Complimentary Tinted Lip Jelly if Core Four + Serum
        // const id = form.find(x => x.name === 'id')?.value
        // if (["40264443625669", "40264443658437", "40264443691205", "40264443723973"].includes(id)) {
        //     form.push({name: 'addon5', value: '43923140083930'})
        // }

        const addons = getAddons(form)

        if (addons) {
            let item = form.reduce((acc, { name, value }) => ({ ...acc, [name]: value }), {})
            item['properties'] = { 'addons': addons }

            data = { items: [...addons, item]}
        }

        return data
    }

    const updateCart = (type, isAnotherCall = true) => {
        var ajax = (!type || type === 'popup') ? 'popup' : 'page'
        let freeSelected = $('#cart-select').find(':selected').val()
        let freeClass = $('#free_product').attr('class')
        $.ajax({
            url: `${window.language}/cart?view=${ajax}`,
            success: function (response) {
                if (ajax === 'page') {
                    $('#cart-page').html(response)
                    if (isAnotherCall) {
                        updateCart('popup', false)
                    }
                } else {
                    $('#cart-popup-content').html(response)
                    FreeProductUpdate(freeSelected)
                    if (freeClass) FreeProductSelect(freeClass)
                    customSelect()
                    if (isAnotherCall) {
                        $('.cart-popup-wrapper').removeClass('d-none').addClass('d-block')
                        updateCart('page', false)
                    }
                }
            }
        })
    }

    const getCartData = () => {
        $.ajax({
            url: `${window.language}/cart.js`,
            dataType: 'json',
            cache: false,
            type: 'get',
            success: function (response) {
                addFreeRoseLipJelly(response);
            }
        });
    }
    
    const addFreeRoseLipJelly = (cart) => {
        let priceBeforeChange = $('.selected-items-wrapper');
        let totalPriceWithoutSubscription = cart.total_price;
        let haveFreeRose = false;
        let is_added = false;

        $.each(cart.items, function(index, item) {
            if (item.id === 42090877518042 && item.final_line_price === 0) {
                haveFreeRose = true;
            }

            if (item.selling_plan_allocation) {
                totalPriceWithoutSubscription -= item.final_line_price;
            }
        });


        if (priceBeforeChange.data('price')) {
            is_added = priceBeforeChange.data('price') < cart.total_price
        } else {
            is_added = 0 < cart.total_price
        }
        
        if (totalPriceWithoutSubscription > 5000 && !haveFreeRose && is_added) {
            return shopifyAPI('add', {
                "items": [
                    {
                        "id": "42090877518042",
                        "properties": {
                            "addons": []
                        }
                    }
                ]
            });
        }
    }

    const updateCartQuantity = () => {
        return $.ajax({
            url: `${window.language}/cart.js`,
            dataType: 'json',
            cache: false,
            type: 'get',
            success: function (response) {
                window.cart = response

                // Add Toiletry Bag if cart total >= $50
                // const bag = response.items.find(item => item.id === 42533710299354)
                // if (response.total_price >= 5000) {
                //     if (!bag) {
                //         shopifyAPI('add', {id: 42533710299354})
                //     }
                // } else {
                //     if (bag) {
                //         let updates = {}
                //         updates[bag.key] = 0
                //         shopifyAPI('update', {updates})
                //     }
                // }

                var count = response.item_count
                let $cartItem = $('.cart-items-quantity')
                $cartItem.text(count)

                if (count > 0) {
                    $cartItem.removeClass('black-color')
                    $('.checkout').show()
                } else {
                    $cartItem.addClass('black-color')
                    $('.checkout').hide()
                }
            }
        })
    }

    const quantityUpdateData = ($this) => {
        var line = $this.data('line')
        var quantity = $this.data('value')

        let data = { line, quantity }
        let action = 'change'

        var cartLine = window.cart.items[line - 1]
        if (cartLine.properties && cartLine.properties.addons) {
            let updates = {}
            updates[cartLine.key] = quantity

            Object.values(cartLine.properties.addons).forEach((addonObj) => {
                const addon = addonObj.id
                const addonSellingPlan = addonObj.selling_plan
                const addonParent = cartLine.id

                let addonLineIndex = window.cart.items.findIndex(function (item) {
                    if (addonSellingPlan) {
                        return item.id === parseInt(addon) && parseInt(item.properties.p) === parseInt(addonParent) && !!item.selling_plan_allocation
                    } else {
                        return item.id === parseInt(addon) && parseInt(item.properties.p) === parseInt(addonParent) && !item.selling_plan_allocation
                    }
                })

                if (addonLineIndex <= -1) {
                    addonLineIndex = window.cart.items.findIndex(function (item) {
                        if (addonSellingPlan) {
                            return item.id === parseInt(addon) && !!item.selling_plan_allocation
                        } else {
                            return item.id === parseInt(addon) && !item.selling_plan_allocation
                        }
                    })
                }

                if (addonLineIndex > -1) {
                    const addonLine = window.cart.items[addonLineIndex]

                    updates[addonLine.key] = quantity
                }
            })

            data = { updates }
            action = 'update'
        }

        return { action, data }
    }

    const clearCart = () => {
        return $.ajax({ url: `${window.language}/cart/clear.js`, type: 'post' })
    }

    window.cart = { items: {} }
    updateCartQuantity()

    $body.on('submit', '.AddToCartForm', async function (e) {
        e.preventDefault()

        if ($(this).data('clear') !== undefined) {
            await clearCart()
        }

        let data = addToCartData($(this))

        shopifyAPI('add', data)
    })

    $body.on('click', '.AddToCartDiv button', function (e) {
        e.preventDefault()

        shopifyAPI('add', { id: $(this).siblings('input').val() })
    })

    $body.on('click', '.AddToCartAll', function (e) {
        var productForms = $('.quiz-result_item .AddToCartForm.OneTime').serializeArray()
        var items = []
        productForms.forEach(function (form) {
            items.push({
                id: form.value,
                quantity: 1
            })
        })

        shopifyAPI('add', { items })
    })

    $body.on('click', '.quantity-change', function () {
        var type = $(this).data('type')

        const { action, data } = quantityUpdateData($(this))

        shopifyAPI(action, data, type).then((response, error) => {
            if (error.status === 422) {
                data.quantity = 0
                shopifyAPI('change', data)
            }
        })
    })

    $body.on('click', '.bggle_button-link', function (e) {
        if ($(this).find('button').text().toLowerCase().includes('cart')) {
            e.preventDefault()
            const productHandle = $(this).attr('href')

            $.getJSON(`${window.language}${productHandle}.js`).then((resp) => {

                shopifyAPI('add', {id: resp.variants[0].id})
            })
        }
    })


    let savingNote = null

    const saveNote = (note) => {
        $.ajax({
            url: `${window.language}/cart/update.js`,
            type: 'POST',
            data: { note }
        })
    }

    $body.on('keyup', '.cart-notes', function () {
        const note = $(this).val().trim()
        if (savingNote) clearTimeout(savingNote)
        if (note === '') {
            saveNote(note)
            return
        }

        savingNote = setTimeout(function () {
            saveNote(note)
        }, 500)
    })

    $body.on('change', '#cart-select', () => {
        FreeProductUpdate()
        FreeProductSelect()
    })

    $(window).on('load', () => FreeProductUpdate())
    $body.on('click', '.free_product_button', () => FreeProductSelect())

    function FreeProductUpdate (selectedValue = null) {
        if (selectedValue) {
            $('#cart-select').val(selectedValue).change().selectric('refresh')
        }

        let _this = $('#cart-select').find(':selected')

        let img = _this.attr('data-img')
        let url = _this.attr('data-url')
        let id = _this.attr('data-id')

        $('.select-img').attr('src', img)
        $('.select-url').attr('href', url)
        $('.select-id').attr('value', id)
    }

    function FreeProductSelect (title_class) {
        let input_product_value = $body.find('.select-id').val()
        let free_product_title = $body.find('#free_product')

        if (title_class) {
            free_product_title.attr('class', title_class)
        } else {
            if (!input_product_value) {
                free_product_title.addClass('color-red')
            } else {
                free_product_title.removeClass('color-red')
            }
        }
    }
})
/*--- /.Add To Cart ---*/
